import GoldIcon from './assets/gold.svg'
import Piggybank from './assets/piggy-bank-mod.svg'
import Selection from './assets/selection-mod.svg'
import Research from './assets/research-mod.svg'
import PatternRecognition from './assets/pattern-recognition-mod.svg'

export const indexMethodIcon = {
  high_quality: GoldIcon,
  economical: Piggybank,
}

export const retrievalIcon = {
  vector: Selection,
  fullText: Research,
  hybrid: PatternRecognition,
}
